import React from 'react';
import ReactDOM from 'react-dom/client';

import emailjs from '@emailjs/browser';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import "mdb-react-ui-kit/dist/css/mdb.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import './index.css';

import App from './App';

emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
